export default __webpack_public_path__ + "static/media/dbbanner.457b699c.jpg";